import styled from 'styled-components';

export const Text = styled.div`
  text-align: justify;
  margin: 0 8%;
  line-height: 2.2rem;
`;
